unit Client.Settings;

interface

uses System.SysUtils, WEBLib.Cookies, WEBLIB.Storage;

type
  TSettings = class
  private
    // Hitre opombe pri odvozu
    FNote1: string;
    FNote2: string;
    FNote3: string;

    // Zemljevid
    FDefaultZoom: integer;
    FDevMode: boolean;
    FDarkMode: boolean;

    // GPS
    FLocationInterval: integer;   // 0 = onemogočeno
    FLocationLength: integer;

    function GetDevMode: boolean;
    function GetDarkMode: boolean;
    procedure SetDarkMode(const Value: boolean);
    function GetServerURL: string;

    function GetVar(TokenName: string): string;
    procedure SetVar(TokenName, Value: string);
  public
    constructor Create; reintroduce;

    property ServerURL: string read GetServerURL;

    property DevMode: boolean read GetDevMode;
    property DarkMode: boolean read GetDarkMode write SetDarkMode;
  end;

var
  AppSettings: TSettings;

implementation

{ TSettings }

uses Client.Core;

constructor TSettings.Create;
begin
  inherited Create;

  FDarkMode := StrToBoolDef(GetVar('Application.DarkMode'), false);

  FLocationInterval := StrToIntDef(GetVar('Location.Interval'), 30);
  FLocationLength := StrToIntDef(GetVar('Location.LocationLength'), 200);

  FNote1 := GetVar('Note1');
  FNote2 := GetVar('Note2');
  FNote3 := GetVar('Note3');

  FDefaultZoom := StrToIntDef(GetVar('Location.Zoom'), 17);
end;

function TSettings.GetDevMode: boolean;
begin
  Result := FDevMode;
end;

function TSettings.GetDarkMode: boolean;
begin
  Result := FDarkMode;
end;

function TSettings.GetServerURL: string;
begin
  Result := 'https://kamijoncinapidev.okoljepiran.si/kamijoncin';  // Dev
//  Result := 'https://kamijoncinapi.okoljepiran.si/kamijoncin';  // Production
//  Result := 'http://localhost:2001/kamijoncin'; // Dev local
end;

procedure TSettings.SetDarkMode(const Value: boolean);
begin
  FDarkMode := Value;
  SetVar('Application.DarkMode', Value.ToString);
end;

function TSettings.GetVar(TokenName: string): string;
var
  ls: TLocalStorage;
begin
(*  Result := '';
  ls := TLocalStorage.Create;
  try
    Result := ls.GetValue(TokenName);
  finally
    ls.free;
  end; *)
end;

procedure TSettings.SetVar(TokenName, Value: string);
var
  ls: TLocalStorage;
begin
//  ClearMyToken; // clear it first - not strictly necessary
(*  ls := TLocalStorage.Create;
  try
    ls.SetValue(TokenName, Value);
  finally
    ls.free;
  end; *)
end;

initialization

end.
